import { render, staticRenderFns } from "./categorySelector.vue?vue&type=template&id=3163789e&scoped=true"
import script from "./categorySelector.vue?vue&type=script&lang=js"
export * from "./categorySelector.vue?vue&type=script&lang=js"
import style0 from "./categorySelector.vue?vue&type=style&index=0&id=3163789e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163789e",
  null
  
)

export default component.exports